<!--unOption
 * @description: 任务中心列表页面
 * @fileName: List.vue
!-->
<template>
  <div class="taskCenterList section-main__warp">
    <!-- start @description: 表格 !-->
    <div class="table" v-show="!colorNum">
      <ioc-table
          ref="iocTable"
          :option="unOption"
          :data="taskCenterData"
          @sort-change="sortChange"
          @search-change="searchResult"
          @search-reset="resetQuery"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page="page"
          @cell-click="cellTaskDetail"
      >
        <!-- 表格的列自定义 -->
        <template slot="taskName" slot-scope="scope">
          {{ scope.row.taskName }}
        </template>
        <template slot="creatorName" slot-scope="scope">
          {{ scope.row.creatorName }}
        </template>
        <template slot="menu" slot-scope="scope">
          <div class="pl10">
            <!-- 修改 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.modify')"
                placement="top"
                v-auth="'/fireTaskCenter/list:update'"
                popper-class="tooltip-draw"
                v-if="
                getBottomState(scope.row.status, $t('taskCenter.label.noStart'))
              "
            >
              <el-button
                  type="text"
                  @click="editTask(scope.row)"
                  icon="iconfont icon-xiugai"
              ></el-button>
            </el-tooltip>
            <!-- 审核 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.review')"
                v-auth="'/fireTaskCenter/list:update'"
                placement="top"
                popper-class="tooltip-draw"
                v-if="
                getBottomState(scope.row.status, $t('taskCenter.label.wait'))
              "
            >
              <el-button
                  type="text"
                  @click="auditTask(scope.row)"
                  icon="iconfont icon-yiwancheng"
              ></el-button>
            </el-tooltip>
            <!-- 删除 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.delete')"
                placement="top"
                popper-class="tooltip-draw"
                v-if="
                getBottomState(scope.row.status, $t('taskCenter.label.noStart'))
              "
            >
              <el-button
                  type="text"
                  @click="deleteTask(scope.row)"
                  icon="iconfont icon-shanchu"
              ></el-button>
            </el-tooltip>
            <!-- 启动 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.start')"
                placement="top"
                popper-class="tooltip-draw"
                v-if="
                getBottomState(scope.row.status, $t('taskCenter.label.noStart'))
              "
            >
              <el-button
                  type="text"
                  @click="startTask(scope.row)"
                  icon="iconfont icon-qiyong"
              ></el-button>
            </el-tooltip>
            <!-- 关闭 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.close')"
                placement="top"
                popper-class="tooltip-draw"
                v-if="
                getBottomState(
                  scope.row.status,
                  $t('taskCenter.label.executing')
                ) ||
                getBottomState(scope.row.status, $t('taskCenter.label.wait'))
              "
            >
              <el-button
                  type="text"
                  @click="closeTask(scope.row)"
                  icon="el-icon-close"
              ></el-button>
            </el-tooltip>
            <!-- 详情 -->
            <el-tooltip
                class="item"
                effect="dark"
                :content="$t('taskCenter.label.detail')"
                placement="top"
                popper-class="tooltip-draw"
            >
              <el-button
                  type="text"
                  @click="taskDetails(scope.row)"
                  icon="iconfont icon-Detail"
              ></el-button>
            </el-tooltip>
          </div>
        </template>
        <template slot="status" slot-scope="scope">
          <span style="cursor: pointer" @click="taskDetails(scope.row)">{{
              scope.row.status | dic("SENU012")
            }}</span>
        </template>
      </ioc-table>
    </div>
    <div v-show="colorNum">
      <ioc-table
          :option="option"
          :data="taskCenterData"
          @sort-change="sortChange"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page="page"
          @cell-click="cellTaskDetail"
      ></ioc-table>
    </div>
    <task-close ref="closeTask" :taskCode="taskCode" @closeTaskSuccess="closeTaskSuccess"/>
    <!-- end @description: 表格-操作栏-关闭任务 !-->
    <assignDialog ref="taskAssign" @childByValue="childByValue"/>
    <taskDetail ref="taskDetail" @closeTaskSuccess="closeTaskSuccess"/>
    <taskAudit ref="taskAudit" :taskAuditInfo="taskAuditInfo" @childByData="childByData"/>
  </div>
</template>
<script>
import { API } from "@ISS/taskCenter/api";
import { Dates, Dic } from "$utils";
import { finish, unFinish } from "../options/table";
import assignDialog from "../components/TaskAssignComponent";
import taskDetail from "../components/TaskDetailComponent";
import taskClose from "../components/closeTask";
import taskAudit from "../components/TaskAuditComponent";
import utils from "@src/common/utils";
export default {
  components: {
    assignDialog,
    taskDetail,
    taskAudit,
    taskClose,
  },
  data() {
    return {
      allStatus: false,
      isIndeterminateStatus: false,
      allPrioritys: false,
      isIndeterminatePrioritys: false,
      allTypes: false,
      isIndeterminateTypes: false,
      // 关闭原因
      taskCode: "",
      status: Dic.find("SENU012"), // 状态 启动
      prioritys: Dic.find("SENU008"), // 优先级
      taskTypes: Dic.find("SENU010"), // 类型
      taskVisibilit: Dic.find("SENU009"), //可见性
      taskCloseData: {},
      taskCloseReason: "",
      taskCloseReasonDes: "",
      // 关闭选项
      closeInfo: [
        {
          value: "1",
          label: this.$t("taskCenter.message.dealSuc"),
        },
        {
          value: "2",
          label: this.$t("taskCenter.message.taskEAnd"),
        },
      ],
      taskInfo: {
        // 仅显示我指派的
        onlyAssign: false,
        // 指派人
        fAssignerName: "",
        // 执行人
        executorName: "",
        // 搜索开始日期
        startTime: "",
        // 搜索结束日期
        finishTime: "",
        // 任务状态
        fStatus: [],
        // 优先级
        fPriority: [],
        // 任务类型
        fType: [],
        // 任务名称
        taskName: "",
      },
      order: "",
      exportType: "",
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      taskCenterData: [],
      colorNum: true,
      option: finish(this),
      unOption: unFinish(this),
      // 任务指派信息
      taskAssignInfo: "",
      taskAuditInfo: {},
      taskModInfo: {},
      isEdit: false, // 是否是修改，默认添加
      cacheParam: {},
      defaultFinishTime: "",
      defaultStartTime: "",
      disabled: false, //导出按钮是否禁用
    };
  },
  created() {},
  mounted() {
    // console.log("status", this.status);
    let flag = this.$route.params.mark;
    if (flag == 3) {
      this.getFinishedTask();
    } else if (flag == 4) {
      this.taskInfo.onlyAssign = true;
      this.colorNum = false;
      this.searchList();
    } else {
      this.getUnfinishedTask();
      //  this.getList()
    }
  },
  methods: {
    // 导出 此功能暂时屏蔽
    exportFile() {
      if (
          (!this.taskInfo.startTime && this.taskInfo.finishTime) ||
          (!this.taskInfo.finishTime && this.taskInfo.startTime)
      ) {
        this.$message.warning(this.$t("taskCenter.message.selectdate"));
        return;
      }
      this.filterTime();
      let start_time = Dates.format(
          new Date(this.taskInfo.startTime),
          "yyyy/MM/dd 00:00:00"
      );
      let end_time = Dates.format(
          new Date(this.taskInfo.finishTime),
          "yyyy/MM/dd 23:59:59"
      );
      let startTime = new Date(start_time).getTime();
      let endTime = new Date(end_time).getTime();
      if (endTime - startTime > 30 * 24 * 60 * 60 * 1000) {
        this.$message.warning(this.$t("taskCenter.message.export30"));
        return;
      }
      let params = {
        taskName: this.taskInfo.taskName,
        createName: this.taskInfo.fAssignerName,
        executorName: this.taskInfo.executorName,
        // taskTypeList: this.getValueByLabel(this.taskTypes, this.taskInfo.fType),
        // taskPriorityList: this.getValueByLabel(
        //   this.prioritys,
        //   this.taskInfo.fPriority
        // ),
        taskStatus: this.taskInfo.taskStatus,
        // taskStatus: this.getValueByLabel(this.status, this.taskInfo.taskStatus),
        isMyCreate: this.taskInfo.onlyAssign,
        startTime: this.taskInfo.startTime,
        endTime: this.taskInfo.finishTime,
        order: this.order,
        exportType: this.exportType,
      };
      if (!this.taskInfo.startTime && !this.taskInfo.finishTime) {
        this.$confirm(
            this.$t("taskCenter.message.createDate"),
            this.$t("taskCenter.button.prompt"),
            {
              confirmButtonText: this.$t("taskCenter.button.conform"),
              cancelButtonText: this.$t("taskCenter.button.cancel"),
              type: "warning",
            }
        ).then(() => {
          this.fetchDownLoadFile(params);
          return;
        });
      } else {
        this.fetchDownLoadFile(params);
      }
    },
    fetchDownLoadFile(params) {
      this.disabled = true;
      this.$fetchDownLoad(API.bas.exportTask, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        // debugger
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName =
            this.$t("taskCenter.title.taskRecords") +
            Dates.format(Date.now(), "yyyyMMddHHmmssms") +
            ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.disabled = false;
      });
    },
    // 关闭任务成功
    closeTaskSuccess() {
      this.$refs.taskDetail && this.$refs.taskDetail.cancel();
      this.getUnfinishedTask();
    },
    // 根据select的值 改变input框的值
    changeValue() {
      this.taskCloseReasonDes = "";
      this.taskCloseReasonDes = this.taskCloseReason;
    },
    // 判断状态中某一对键值是否匹配
    getBottomState(rowState, stateTxt) {
      const index = this.status.findIndex((item) => item.value === rowState);
      return index > -1 ? this.status[index].label === stateTxt : false;
    },
    // 根据label返回value
    getValueByLabel(dataList, labelList) {
      let rtn = [];
      dataList.map((item) => {
        if (labelList.findIndex((label) => label === item.label) > -1) {
          rtn.push(item.value);
        }
      });
      return rtn;
    },
    // 完成任务按钮触发
    getFinishedTask(param) {
      this.colorNum = true;
      this.exportType = 0;
      if (param) {
        this.page.currentPage = 1;
        // 触发按钮的时候需要去清空
        this.clearCondition();
      }
      this.getList(param);
    },
    getList(data) {
      let arrStatus = [];
      arrStatus = data?.status;
      arrStatus
          ? (this.cacheParam.taskStatus = arrStatus.map((item) => {
            return item + "";
          }))
          : (this.cacheParam.taskStatus = []);
      this.cacheParam.executorName = data?.executorNames;
      this.cacheParam.taskName = data?.taskName;
      this.cacheParam.order = this.cacheParam.order
          ? this.cacheParam.order
          : "t.taskPriority asc,t.createTime desc";
      this.cacheParam.startTime = this.taskInfo.startTime
          ? this.taskInfo.startTime
          : this.defaultStartTime;
      this.cacheParam.endTime = this.taskInfo.finishTime
          ? this.taskInfo.finishTime
          : this.defaultFinishTime;
      this.cacheParam.pageNum = this.page.currentPage;
      this.cacheParam.pageSize = this.page.pageSize;
      this.cacheParam.isMyCreate = this.taskInfo.onlyAssign;
      this.cacheParam.subSystemList = [4, 13, 14];
      // let url = this.colorNum ? API.bas.queryHisTaskInfo : API.bas.queryUndoTaskInfo
      let url = API.bas.queryAllTaskInfo;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(url, this.cacheParam).then((res) => {
        loading.close();
        if (res.success) {
          this.taskCenterData = Object.freeze(res.returnObj.list);
          this.page.total = Object.freeze(res.returnObj.total);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 未完成任务按钮触发
    getUnfinishedTask(param) {
      this.colorNum = false;
      this.exportType = 1;
      // if (param) {
      //   this.page.currentPage = 1;
      //   // 触发按钮的时候需要去清空
      //   this.clearCondition();
      // }
      if (!this.taskInfo.startTime) {
        this.getDefaultTime();
      }
      this.getList(param);
    },
    //获取当前时间,默认查询三个月
    getDefaultTime() {
      let currentDate = new Date();
      this.defaultFinishTime = this.taskInfo.finishTime = Dates.format(
          currentDate,
          "yyyy-MM-dd"
      );
      this.defaultStartTime = this.taskInfo.startTime = Dates.format(
          currentDate.setMonth(currentDate.getMonth() - 3),
          "yyyy-MM-dd"
      );

      this.$set(this.$refs.iocTable.searchForm, "createTime", [
        this.defaultStartTime,
        this.defaultFinishTime,
      ]);
    },
    // 筛选时间
    filterTime() {
      let finishTime = Date.parse(this.taskInfo.finishTime);
      let startTime = Date.parse(this.taskInfo.startTime);
      // 根据查询条件
      if (startTime > finishTime) {
        this.$message.error(this.$t("taskCenter.message.timeMore"));
      }
      this.taskInfo.finishTime = Dates.format(finishTime, "yyyy-MM-dd");
      this.taskInfo.startTime = Dates.format(startTime, "yyyy-MM-dd");
    },

    // 搜索
    searchList() {
      this.page.currentPage = 1;
      this.filterTime();
      this.cacheParam = {
        taskName: this.taskInfo.taskName,
        // taskStatus: this.taskInfo.taskStatus + "",
        createName: this.taskInfo.fAssignerName,
        executorName: this.taskInfo.executorName,
        // taskTypeList: this.getValueByLabel(this.taskTypes, this.taskInfo.fType),
        // taskPriorityList: this.getValueByLabel(
        //   this.prioritys,
        //   this.taskInfo.fPriority
        // ),
        taskStatus: this.taskInfo.taskStatus.map((item) => {
          return item + "";
        }),
        // taskStatus: this.getValueByLabel(this.status, this.taskInfo.taskStatus),
        isMyCreate: this.taskInfo.onlyAssign,
        startTime: this.taskInfo.startTime,
        endTime: this.taskInfo.finishTime,
        // order: this.order,
      };
      this.getList();
    },
    /*
     *@name: 查询信息清空
     *@param:{type}
     */
    clearSearch() {
      this.clearCondition();
      // 查询
      this.page.currentPage = 1;
      this.filterTime();
      this.getList();
    },
    clearCondition() {
      this.isIndeterminateTypes = false;
      this.isIndeterminateStatus = false;
      this.isIndeterminatePrioritys = false;
      this.allStatus = false;
      this.allPrioritys = false;
      this.allTypes = false;
      this.taskInfo.onlyAssign = false;
      this.taskInfo.fAssignerName = "";
      this.taskInfo.taskName = "";
      this.taskInfo.fStatus = [];
      this.taskInfo.fPriority = [];
      this.taskInfo.fType = [];
      this.taskInfo.taskName = "";
      this.taskInfo.taskStatus = [];
      this.getDefaultTime(); // 回填默认时间
      this.cacheParam = {};
    },
    // 详情按钮触发
    taskDetails(taskInfo) {
      this.$refs.taskDetail.open(taskInfo.code);
    },
    // 任务名称单元格触发
    cellTaskDetail(row, column) {
      if (column.property == "taskName") {
        this.taskDetails(row);
      } else {
        return false;
      }
    },
    // 修改触发
    editTask(taskInfo) {
      let params = {
        taskCode: taskInfo.code,
      };
      this.$fetch(API.bas.queryTaskInfo, params).then((res) => {
        if (res.success) {
          if (res.returnObj.taskInfo.status != 1) {
            this.$message.error(this.$t("taskCenter.message.statusRe"));
            this.getUnfinishedTask();
            return;
          }
          this.isEdit = true;
          this.$refs.taskAssign.open(res.returnObj);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    reviewTask(row) {
      this.dialogVisible = true;
      this.reviewInfo = row;
    },
    // 审核按钮触发
    auditTask(data) {
      let params = {
        taskCode: data.code,
      };
      this.$fetch(API.bas.queryChecktaskInfo, params).then((res) => {
        if (res.success) {
          this.taskAuditInfo = res.returnObj;
          console.log("审核数据", this.taskAuditInfo);
          this.$refs.taskAudit.open();
          this.$nextTick(() => {
            this.$refs.taskAudit.getAuditInfo(this.taskAuditInfo);
          }, 200);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 删除触发
    deleteTask(data) {
      this.$confirm(
          this.$t("taskCenter.message.deleteWarn"),
          this.$t("taskCenter.button.prompt"),
          {
            confirmButtonText: this.$t("taskCenter.button.conform"),
            cancelButtonText: this.$t("taskCenter.button.cancel"),
            type: "warning",
          }
      )
          .then(() => {
            this.$fetch(API.bas.deleteTaskInfo, {
              taskCodes: [data.code],
            }).then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: this.$t("taskCenter.message.deleteOk"),
                });
                this.getUnfinishedTask();
              } else {
                this.$message({
                  type: "error",
                  message: res.msgContent,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("taskCenter.message.cancelDel"),
            });
          });
    },
    // 启动
    startTask(data) {
      this.$confirm(
          this.$t("taskCenter.message.startTask"),
          this.$t("taskCenter.button.prompt"),
          {
            confirmButtonText: this.$t("taskCenter.button.conform"),
            cancelButtonText: this.$t("taskCenter.button.cancel"),
            type: "warning",
          }
      ).then(() => {
        let params = {
          taskCode: data.code,
        };
        this.$fetch(API.bas.startTaskInfo, params).then((res) => {
          if (res.success) {
            this.$message({
              message: this.$t("taskCenter.message.taskSucc"),
              type: "success",
            });
            this.getUnfinishedTask();
          } else {
            this.$message({
              message: res.error,
              type: "error",
            });
          }
        });
      });
    },
    // 关闭触发
    closeTask(taskCode) {
      this.$nextTick(() => {
        this.$refs.closeTask.taskCloseStatus = true;
        this.taskCode = taskCode.code;
      });
    },
    // 排序触发
    sortChange(val) {
      if (val.prop == "taskPriority" && val.order == "ascending") {
        this.order = "t.taskPriority asc";
      } else if (val.prop == "taskPriority" && val.order == "descending") {
        this.order = "t.taskPriority desc";
      } else if (val.prop == "createTime" && val.order == "ascending") {
        this.order = "t.createTime asc";
      } else if (val.prop == "createTime" && val.order == "descending") {
        this.order = "t.createTime desc";
      } else {
        this.order = "";
      }
      this.cacheParam.order = this.order;
      if (this.colorNum) {
        this.getFinishedTask();
      } else {
        this.getUnfinishedTask();
      }
    },
    // 指派任务触发
    assignTask() {
      this.isEdit = false;
      this.$refs.taskAssign.open();
    },
    // 审核提交
    childByData(childByData) {
      let params = childByData;
      this.$fetch(API.bas.checkTaskInfo, params).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: this.$t("taskCenter.message.reSuc"),
          });
          this.$refs.taskAudit.close();
          this.getUnfinishedTask();
        } else {
          this.$message({
            type: "error",
            message: res.msgContent,
          });
        }
      });
    },
    // 指派提交
    async childByValue(childByValue) {
      let url = API.bas.updateTaskInfo;
      this.taskAssignInfo = childByValue;
      // 修改
      if (!this.isEdit) {
        url = API.bas.addTaskInfo;
      }
      this.$fetch(url, this.taskAssignInfo).then((res) => {
        if (res.success) {
          this.$refs.taskAssign.close();
          this.getUnfinishedTask();
          this.$message({
            message:
                (this.isEdit
                    ? this.$t("taskCenter.label.modify")
                    : this.$t("taskCenter.label.add")) +
                this.$t("taskCenter.label.success"),
            type: "success",
          });
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 根据label返回value
    getAllLabel(dataList) {
      let rtn = [];
      dataList.map((item) => {
        rtn.push(item.label);
      });
      return rtn;
    },
    // 任务状态
    handleCheckAllStatu(val) {
      this.taskInfo.fStatus = val ? this.getAllLabel(this.status) : [];
      this.isIndeterminateStatus = false;
    },
    // 任务状态选择
    handleCheckedStatuChange(value) {
      let checkedCount = value.length;
      this.allStatus = checkedCount === this.status.length;
      this.isIndeterminateStatus =
          checkedCount > 0 && checkedCount < this.status.length;
    },
    // 优先级
    handleCheckAllPriority(val) {
      this.taskInfo.fPriority = val ? this.getAllLabel(this.prioritys) : [];
      this.isIndeterminatePrioritys = false;
    },
    // 优先级选择
    handleCheckedPriorityChange(value) {
      let checkedCount = value.length;
      this.allPrioritys = checkedCount === this.prioritys.length;
      this.isIndeterminatePrioritys =
          checkedCount > 0 && checkedCount < this.prioritys.length;
    },
    // 任务类型
    handleCheckAllType(val) {
      this.taskInfo.fType = val ? this.getAllLabel(this.taskTypes) : [];
      this.isIndeterminateTypes = false;
    },
    // 任务类型选择
    handleCheckedTypeChange(value) {
      let checkedCount = value.length;
      this.allTypes = checkedCount === this.taskTypes.length;
      this.isIndeterminateTypes =
          checkedCount > 0 && checkedCount < this.taskTypes.length;
    },
    searchResult(data) {
      console.log(data, "search");
      if (data.createTime && data.createTime.length) {
        this.taskInfo.startTime = Dates.format(
            data.createTime[0],
            "yyyy-MM-dd"
        );
        this.taskInfo.finishTime = Dates.format(
            data.createTime[1],
            "yyyy-MM-dd"
        );
      }
      if (this.colorNum) {
        this.getFinishedTask(data);
      } else {
        this.getUnfinishedTask(data);
      }
    },
    resetQuery() {
      this.taskInfo.startTime = "";
      this.taskInfo.finishTime = "";
      if (this.colorNum) {
        this.getFinishedTask();
      } else {
        this.getUnfinishedTask();
      }
    },
    // 分页 页面跳转
    handleCurrentChange(val) {
      this.page.currentPage = val;
      if (this.colorNum) {
        this.getFinishedTask();
      } else {
        this.getUnfinishedTask();
      }
    },
    // 分页 每页显示行数
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      if (this.colorNum) {
        this.getFinishedTask();
      } else {
        this.getUnfinishedTask();
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.el-time-spinner__item.active:not(.disabled) {
  // color: #fff;
  @include set_theme_color(color,main-theme-color);
}
.el-table .cell.el-tooltip {
  white-space: break-spaces;
}
.el-time-panel__btn {
  color: #606266;
}
.taskCenterList {
  display: flex;
  width: 100%;
  flex-direction: column;

  .sparate-line {
    width: 100%;
    border-bottom: solid 1px #3f5273;
  }
  .btn-style {
    // width: 100px;
    padding: 9px 15px;
    border: 0;
  }
  .el-checkbox {
    margin-right: 10px;
  }
  .task-center-form-item {
    margin-left: 30px;
  }
  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }

  >>> .el-time-panel {
    @include set_theme_color(background-color, dialog-content-bg-color);
  }
}

.taskCenterList .table {
  display: flex;
  flex: 1;
  min-height: 0;
}
</style>
